<template>
     <div class="mask-translucent union-dialog" :class="{'hide':!options.isshow,'operation':options.isOperation}">
        <div class="dialog-wrap">
            <span class="i-logo"><img src="../../assets/images/i_logo.png"></span>
            <span class="corner-close" @click="closeAtonce" v-if="options.isCornerClose"></span>
            <div class="dialog-title">{{d_title}}</div>
            <div class="dialog-cont" v-if="options.isSlot">
                <slot></slot>
            </div>
            <div class="dialog-cont" v-html="options.cont" v-else></div>
            <div class="handler" v-if="options.dialogType == 1 && d_isclosebtn">
                <button class="ensure" @click="close">{{d_btntxt}}</button>
            </div>
            <div class="handler handle-confirm" v-else-if="options.dialogType == 2">
                <button class="cancel" @click="handleCancel">{{options.btnCancelTxt}}</button>
                <button class="confirm" @click="close">{{options.btnSureTxt}}</button>
            </div>
            <div class="handler share" v-else-if="options.dialogType == 3">
                <span class="channel" @click="shareAppMessage">
                    <img class="icon" src="../../assets/images/i_wechat.png">
                    发送给他（她）
                </span>
                <span class="channel" @click="shareTimeLine">
                    <img class="icon" src="../../assets/images/i_timeline.png">
                    分享到朋友圈
                </span>
            </div>
        </div>
    </div>
</template>
<style>
.mask-translucent.union-dialog {
    width: 100%;
    background: rgba(255, 255, 255, 0.5);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1000;
}
.union-dialog{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.union-dialog .dialog-wrap{
    width: 64%;
    max-height: 80%;
    /* overflow-x: hidden;
    overflow-y: auto; */
    background: #ffffff;
    border-radius: 0.1rem;
    box-shadow: 0.05rem 0.05rem 0.4rem rgba(0, 0, 0, 0.6);
    color: #231815;
    position: relative;
}
.union-dialog .i-logo{
    width: 0.8rem;
    height: 0;
    display: block;
    padding-top: 0.8rem;
    margin: -0.4rem auto 0;
    position: relative;

    /* left: 42.5%;
    top: -7.5%; */
}
.union-dialog .i-logo img{
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
}
.union-dialog .dialog-title{
    width: 94%;
    text-align: center;
    font-size: 0.3rem;
    line-height: 0.4rem;
    padding: 0.1rem 3% 0.2rem;
}
.union-dialog .dialog-cont{
    width: 94%;
    max-height: 70%;
    overflow: hidden;
    overflow-y: auto;
    padding: 0.1rem 3% 0.5rem;
    text-align: center;
    font-size: 0.3rem;
    line-height: 0.48rem;
}
.union-dialog .corner-close{
    display: inline-block;
    width: 0.46rem;
    height: 0.46rem;
    border: 1px solid #959595;
    border-radius: 50%;
    position: absolute;
    right: 0;
    top: -0.76rem;
}
.union-dialog .corner-close:before,.union-dialog .corner-close:after{
    content: "";
    display: block;
    width: 1px;
    height: 0.4rem;
    background-color: #959595;
    position: absolute;
    left: 0.22rem;
    top: 0.03rem;
}
.union-dialog .corner-close:before{
    transform: rotate(-45deg);
}
.union-dialog .corner-close:after{
    transform: rotate(45deg);
}
.union-dialog .handler {
    width: 100%;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

}
.union-dialog button {
    display: inline-block;
    padding: 0.1rem 0;
    background-color: transparent;
    text-align: center;
    font-size: 0.32rem;
    line-height: 0.4rem;
    letter-spacing: 0.1rem;
    text-indent: 0.1rem;
    width: 50%;
}
.union-dialog .ensure{
    align-self: center;
    margin: 0 auto 0.2rem;
    width: 94%;
    background-color: #f0861b;
    border-radius: 0.04rem;
    color: #fff;
    /* letter-spacing: 0;
    text-indent: 0; */
}
.union-dialog .handler.handle-confirm{
    border-top: 1px solid #d7d8d8;
}
.union-dialog .handler.handle-confirm button{
    line-height: 0.6rem;
    position: relative;
}
.union-dialog .confirm {
    color: #f0861b;
}
.union-dialog .cancel {
    color: #999999;
}
.union-dialog .cancel:after{
    content: "";
    width: 1px;
    height: 100%;
    display: block;
    background-color: #d7d8d8;
    position: absolute;
    right: 0;
    top: 0;
}
.union-dialog .no-spacing {
    letter-spacing: 0;
    text-indent: 0;
}
/* 分享 */
.union-dialog .handler.share{
    border-top: 1px solid #d7d8d8;
}
.union-dialog .handler.share .channel{
    width: 50%;
    height: 0.8rem;
    padding: 0.06rem 0;
    border-right: 1px solid #d7d8d8;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 0.24rem;
}
.union-dialog .handler.share .channel:last-child{
    border: 0;
}
.union-dialog .handler.share .channel .icon{
    width: 0.5rem;
    margin-right: 0.12rem;
}
/* 操作 */
.union-dialog.operation .dialog-wrap{
    width: 80%;
}
.union-dialog.operation .dialog-cont{
    padding-bottom: 0.36rem;
    margin-top: -0.3rem;
}
.union-dialog .dialog-operation{
    width: 100%;
    display: flex;
    margin-top: 0.16rem;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-end;
    font-size: 0.26rem;
    line-height: 0.34rem;
}
.union-dialog .dialog-operation .text{
    flex: 0 0 auto;
}
.union-dialog .dialog-operation .ipt{
    flex: 1 1 auto;
    width: 1rem;
    height: 0.4rem;
    padding-top: 0.2rem;
    border-bottom: 1px solid #595656;
    text-align: center;
    font-size: 0.28rem;
}
.union-dialog.hide{
    display: none !important;
}
</style>
<script>
export default {
    props:{
        options:{
            isshow:{//是否显示
                type: Boolean,
                default: false
            },
            title:{//标题
                type: String,
                default: "提示"
            },
            cont: {//内容
                type: String,
                default: ""
            },
            cancelauto: {//是否取消自动关闭
                type: Boolean,
                default: false
            },
            life: 10000,//停留时间
            isCornerClose: { //是否显示顶角关闭按钮
                type: Boolean,
                default: false
            },
            isclosebtn: {//是否显示按钮
                type: Boolean,
                default: true
            },
            btntxt: {//按钮文字
                type: String,
                default: "确定"
            },
            callback: {//回调 - 提示框确定按钮、确认框确定按钮
                type: Function
            },
            isCustomClose: { //是否自定义关闭
                type: Boolean,
                default: false
            },
            dialogType: { //对话框类型: 1:alert,2:confirm,3:share,4:custom
                type: String|Number,
                default: 1
            },
            btnSureTxt: { //确认框 - 确定按钮文字
                type: String,
                default: "确定"
            },
            btnCancelTxt: { //确认框 - 取消按钮文字
                type: String,
                default: "取消"
            },
            cancelCallback: {//回调 - 确认框取消按钮
                type: Function
            },
            isSlot: { //是否用插槽
                type: Boolean,
                default: false
            },
            isOperation: { //是否可操作
                type: Boolean,
                default: false
            },
            shareData: { //分享数据
                type: Object,
                default: {}
            },
        }
    },
    data(){
        return{
            d_isauto: true, //自动关闭
            d_title: "提示",
            d_life: 10000,
            d_isclosebtn: true,
            d_btntxt: "确定"
        }
    },
    mounted () {
        if(this.options.title && this.options.title.length > 0){
            this.d_title = this.options.title;
        }
        if(this.options.cancelauto){
            this.d_isauto = false;
        }
        if(this.options.life && this.options.life >= 0){
            this.d_life = this.options.life;
        }
        if(this.options.isclosebtn){
            this.d_isclosebtn = true;
        }
        if(this.options.btntxt && this.options.btntxt.length > 0){
            this.d_btntxt = this.options.btntxt;
        }
        if(this.options.dialogType == 1 && this.d_isauto){
            this.autoclose();
        }
    },
    methods: {
        //自动关闭
        autoclose() {
            let self = this;
            if(self.options.isshow && self && !self._isDestroyed) {
                this.autotimeout = setTimeout(() => {
                    if(self.options.callback){
                        self.options.callback();
                    }
                    self.options.isshow = false;
                    self.options.cont = "";
                    this.destroyTimeout();
                }, self.d_life);
            }
        },
        //关闭
        close() {
            if(this.options.callback){
                this.options.callback();
            }
            if(!this.options.isCustomClose){
                this.options.isshow = false;
                this.options.cont = "";
                //this.d_life = 3000;
                this.destroyTimeout();
            }
        },
        //立刻关闭
        closeAtonce(){
            this.options.isshow = false;
            this.options.cont = "";
        },
        //清除倒计时
        destroyTimeout() {
            clearTimeout(this.autotimeout);
            return;
        },
        //确认框 - 取消按钮
        handleCancel() {
            if(this.options.cancelCallback){
                this.options.cancelCallback();
            }
            this.options.isshow = false;
            this.options.cont = "";
            //this.d_life = 3000;
            // this.destroyTimeout();
        },
        //分享给朋友
        shareAppMessage(){
            console.log("分享给朋友");
            console.log(this.options.shareData);
            this.closeAtonce();
        },
        //分享到朋友圈
        shareTimeLine(){
            console.log("分享到朋友圈");
            console.log(this.options.shareData);
            this.closeAtonce();
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/shared/components/dialog/alert.vue